// Store of all hardcoded codes

const { categories } = require('./codes/categories');
const { clinicalStatuses } = require('./codes/clinicalStatuses');
const { conditions } = require('./codes/conditions');
const { eocTypes } = require('./codes/eocTypes');
const { severities, burnSeverities } = require('./codes/severities');
const { verificationStatuses } = require('./codes/verificationStatuses');
const { fluidResuscitationFormulas } = require('./codes/fluidResuscitationFormulas');
const { tbsaFormulas } = require('./codes/tbsaFormulas');

exports.codes = {
  categories,
  clinicalStatuses,
  conditions,
  eocTypes,
  severities,
  burnSeverities,
  verificationStatuses,
  fluidResuscitationFormulas,
  tbsaFormulas,
};